import React from 'react';
import { Link } from 'react-router-dom';
import { navigationConfig } from '../data/navigationData';

const HomeDropdown = ({ 
  currentPage, 
  variant, 
  dropdownVisible, 
  activeDropdownItem, 
  onToggleDropdown, 
  onItemClick,
  onLinkClick 
}) => {
  const { homeDropdown } = navigationConfig;
  
  const isHomeActive = currentPage === 'home';

  return (
    <li className="nav-item dropdown-container">
      <Link
        to="/"
        className={`nav-link ${isHomeActive ? 'active' : ''}`}
        onMouseEnter={variant === 'overlay' ? onToggleDropdown : undefined}
        onMouseLeave={variant === 'overlay' ? onToggleDropdown : undefined}
        onClick={onLinkClick}
        aria-current={isHomeActive ? 'page' : undefined}
        aria-haspopup={variant === 'overlay' ? 'true' : undefined}
        aria-expanded={variant === 'overlay' ? dropdownVisible : undefined}
      >
        Home {variant === 'overlay' && <span className="dropdown-arrow" aria-hidden="true">&#9662;</span>}
        {variant === 'overlay' && dropdownVisible && (
          <ul className="dropdown" role="menu">
            {homeDropdown.map((item, index) => (
              <li
                key={index}
                role="menuitem"
                className={`dropdown-item ${
                  activeDropdownItem === index ? "active" : ""
                }`}
                onClick={() => onItemClick(index, item.sectionId)}
              >
                {item.name}
              </li>
            ))}
          </ul>
        )}
      </Link>
    </li>
  );
};

export default HomeDropdown;